<template>
  <div class="ranking-list-winners card">
    <div class="card-header">
      <h4 class="card-title">Ganhadores ({{ tickets.length }})</h4>
    </div>
    <div class="card-content">
      <el-table class="table-striped" :data="tickets">
        <el-table-column label="Nome" property="customer" >
          <template slot-scope="scope">
            {{ scope.row.customer.holder }}
            <i v-if="scope.row.checkIn" class="ti-bolt"></i>
          </template>
        </el-table-column>
        <el-table-column width="100" label="UC">
          <template slot-scope="scope"> {{ scope.row.customer.uc }} </template>
        </el-table-column>
        <el-table-column width="80" label="nota">
          <template slot-scope="scope"> {{ scope.row.survey.data.refrigerator.score }} </template>
        </el-table-column>
        <el-table-column width="80" label="Posição">
          <template slot-scope="scope"> {{ scope.row.rankingNow ? scope.row.rankingNow : scope.row.rankingOriginal }} </template>
        </el-table-column>
        <el-table-column width="80" label="Ação">
          <template slot-scope="scope">
            <button @click="$emit('cancelTicket', scope.row._id)" title="Marcar como ausente" class="btn btn-danger btn-fill btn-icon"><i class="ti-close"></i></button>
            </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ranking-list-winners',

  props: ['tickets']
}
</script>



// WEBPACK FOOTER //
// src/pages/Ranking/RankingListWinners.vue